/* eslint-disable react-hooks/exhaustive-deps */
import { openDB } from "idb";
import React, { useEffect, useState, useContext } from "react";
import { v4 as uuidv4 } from "uuid";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import Context from "../context/context";
import { green } from "@mui/material/colors";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { XIcon } from '@heroicons/react/solid';
import { useNavigate } from 'react-router-dom';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import axios from "axios";
import { alpha, styled } from "@mui/material/styles";

import { Switch } from "@mui/material";
const GreenSwitch = styled(Switch)(({ theme }) => ({
  "& .MuiSwitch-switchBase.Mui-checked": {
    color: green[500],
    "&:hover": {
      backgroundColor: alpha(green[500], theme.palette.action.hoverOpacity),
    },
  },
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    backgroundColor: green[500],
  },
}));

const MealScheduling = ({ isMealSchedulingOpen, setIsMealSchedulingOpen }) => {
  const [isNewMenu, setNewMenu] = useState(false)

  const localizer = momentLocalizer(moment)
  const navigate = useNavigate()
  const [events, setEvents] = useState([])
  const [mealsData, setMealsData] = useState([])

  const context = useContext(Context);
  const {
    updateUnSync
  } = context;

  useEffect(() => {
    const getData = async () => {
      const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
      let tx = db.transaction("meal", "readwrite").objectStore("meal");
      let meal = await tx.getAll();
      setMealsData(meal)
    }
    getData()
  }, [])
  const monthNames = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];
  const eventStyleGetter = (event, start, end, isSelected) => {
    let backgroundColor
    if (event.sort_order === "1")
      backgroundColor = "#FF5733";
    else if (event.sort_order === "2")
      backgroundColor = "#701767";
    else if (event.sort_order === "3")
      backgroundColor = "#55FF33";
    else
      backgroundColor = "#334CFF";

    var style = {
      backgroundColor,
      borderRadius: '10px',
      fontSize: "5px",
      color: 'white',
      border: '0px',
    };
    // console.log(event, style, event.sort_order == "2");

    return {
      style: style
    };
  }

  const CalendarToolbar = ({ date, onNavigate }) => {
    let curDate = new Date(date)
    return (
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "50vw", fontSize: "2rem", fontWeight: "bold", marginBottom: "10px" }}>

        <div onClick={() => onNavigate(null, curDate.setMonth(curDate.getMonth() - 1))}>
          <ArrowBackIosIcon />
          <ArrowBackIosIcon />
        </div>
        {/* <ArrowBackIosIcon onClick={() => onNavigate(null, curDate.setDate(curDate.getDate() - 1))} /> */}
        <div onClick={() => onNavigate(null, new Date())}>{"mm-yy"
          .replace(
            "mm",
            monthNames[new Date(date)?.getMonth()]
          )
          .replace(
            "yy",
            (
              "0000" +
              new Date(date)?.getFullYear().toString()
            ).slice(-4)
          )
        }</div>
        {/* <ArrowForwardIosIcon onClick={() => onNavigate(null, curDate.setDate(curDate.getDate() + 1))} /> */}
        <div onClick={() => onNavigate(null, curDate.setMonth(curDate.getMonth() + 1))}>
          <ArrowForwardIosIcon />
          <ArrowForwardIosIcon />
        </div>
      </div>
    );
  }
  useEffect(() => {
    const getData = async () => {
      const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
      let tx = db.transaction("menu", "readwrite").objectStore("menu");
      let MenuData = await tx.getAll();
      let event = MenuData.filter(a => a.menu_type.filter(b => +b === 5).length).map(a => {
        let meal = mealsData.find(b => b.meal_uuid === a.meal_uuid)
        let name = meal?.meal_title

        let date = new Date(parseFloat(a.date))
        return {
          sort_order: meal?.sort_order,
          brand_uuid: a.brand_uuid,
          id: a.menu_uuid,
          name,
          description: "",
          allDay: false,
          start: date,
          end: date
        }
      })
      setEvents(event)
    }
    getData()
  }, [mealsData])


  const event = ({ event }) => {

    return (
      <div style={{ position: "relative" }}>
        {event.name}</div>
    );
  };

  const MenuSyncedOut = async (data) => {

    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const tx = db.transaction("unsynced_files", "readwrite").objectStore("unsynced_files");
    const time = Date.now().toString()
    const ndata = {
      ...data,
      RECON_TIME: time,
      IDENTIFIER: "menu-new:" + data.menu_uuid,
    };
    await tx.put(ndata)
    await handleReconciliation(ndata)
    updateUnSync()
    return true
  }
  const handleReconciliation = async (data) => {
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const tx = await db
      .transaction("reconciliation", "readwrite")
      .objectStore("reconciliation");
    const allReconRecords = await tx.getAll();

    const sectionsJsonExists = allReconRecords.find(
      (curr) => curr.IDENTIFIER === "menu"
    );
    if (sectionsJsonExists) {
      const sections = sectionsJsonExists?.details?.filter(
        (section) => section.menu_uuid !== data.menu_uuid
      );
      const editData = {
        ...sectionsJsonExists,
        details: [
          ...sections,
          {
            menu_uuid: data.menu_uuid,
            RECON_TIME: data.RECON_TIME,
          },
        ],
      };
      await tx.put(editData);
    } else {
      const newdata = {
        IDENTIFIER: "menu",
        details: [
          {
            menu_uuid: data.menu_uuid,
            RECON_TIME: data.RECON_TIME,
          },
        ],
      };
      await tx.add(newdata);
    }
    return true
  };
  return (!isNewMenu ?
    <div className="itemavilablelity">

      <div className="itemavilabelitycontainer" style={{ backgroundColor: "#fff" }}>
        <div className="itemavilablelity_header">
          <h2>Meal Calendar</h2>
          <XIcon style={{ color: "#fff", width: "25px", cursor: "pointer" }} onClick={() => setIsMealSchedulingOpen(false)} />
        </div>

        <div className="availablecontainer">
          <Calendar
            events={events}
            localizer={localizer}
            selectable={true}
            showAllEvents={true}
            view="month"
            eventPropGetter={eventStyleGetter}
            // views={allViews}
            onSelectSlot={e => setNewMenu(e.start)}
            onSelectEvent={(e) => navigate(`/mealMenu/${e.brand_uuid}/${e.id}`)}
            step={60}
            showMultiDayTimes
            defaultDate={new Date()}
            style={{ minHeight: 500 }}
            components={{
              event: event,
              toolbar: CalendarToolbar,

            }}
          />

        </div>


      </div>
    </div> :
    <MealSelection isNewMenu={isNewMenu} mealsData={mealsData} events={events} setNewMenu={setNewMenu} MenuSyncedOut={MenuSyncedOut} />



  )
}

export default MealScheduling

const MealSelection = ({ isNewMenu, mealsData, events, setNewMenu, MenuSyncedOut }) => {
  const [loader, setLoader] = useState(false)
  const [mealsStatusData, setMealsStatusData] = useState([])
  console.log("mealsStatusData", mealsStatusData)
  const navigate = useNavigate()

  const getMealStatus = async ({ meal_uuid }, { start }) => {
    const response = await axios({
      method: "post",
      url: "https://api.myfooddo.com/meal/ViewScheduleStatus",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      data:
      {
        meal_uuid, date: (new Date(start)).getTime().toString()
      },

    })
    if (response.data.success) {
      return { meal_uuid, schedule_status: response?.data?.schedule_status }

    }
    console.log("mealsStatusData", response)

    return {}
  }
  useEffect(() => {
    const fetchData = async () => {
      for (let data of mealsData) {
        let eventsData = events.filter(b => b.name === data.meal_title).filter(b => {
          let c = new Date(isNewMenu)
          let d = new Date(b.start)
          return (c.getDate() === d.getDate() && c.getMonth() === d.getMonth() && c.getFullYear() === d.getFullYear())
        })
        for (let b of eventsData) {
          let dataA = await getMealStatus(data, b)
          setMealsStatusData(prev => [...prev, dataA])
        }

      }
    }
    if (isNewMenu) {

      fetchData()
    }
  }, [])
  const handelSubmit = async (date, meal_uuid) => {
    console.log(date, meal_uuid)
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    let tx = db.transaction("category", "readwrite").objectStore("category");
    let category = await tx.getAll();
    tx = db.transaction("outlet", "readwrite").objectStore("outlet");
    let outlet = await tx.getAll();
    tx = db.transaction("item", "readwrite").objectStore("item");
    let items = await tx.getAll();
    tx = db.transaction("menu", "readwrite").objectStore("menu");
    let id = uuidv4()
    let obj = {
      IDENTIFIER: id,
      brand_uuid: outlet[0].brand_uuid[0] || "",
      category_and_items: category.map((a, i) =>
      ({
        category_uuid: a.category_uuid,
        menu_category_sort_order: i,
        menu_items: items.filter(b => a.category_uuid === b.category_uuid).map((b, ib) => ({
          item_uuid: b.item_uuid,
          menu_item_addons: [],
          menu_item_description: "",
          menu_item_discount: b?.outlet_wise_item_details[0]?.other_details?.item_excluded_from_discount || "0",
          menu_item_label: "",
          menu_item_multi: [],
          menu_item_price: "0",
          menu_item_recommended: "N",
          menu_item_sort_order: ib,
          menu_item_status: b?.outlet_wise_item_details[0]?.other_details?.item_status || "0",
          menu_item_uuid: 12345678,
        }))

      })),
      date: (new Date(Date.UTC(new Date(date)?.getFullYear().toString(), new Date(date)?.getMonth().toString(), new Date(date)?.getDate().toString(), '00', '00', '00'))).getTime(),
      meal_uuid,
      menu_for: ["1", "2", "3"],
      menu_title: "",
      menu_type: ["5"],
      menu_uuid: id,
      outlet_uuid: localStorage.getItem("outlet_uuid"),
    }

    await tx.put(obj)
    await MenuSyncedOut({ ...obj, timezone: sessionStorage.getItem("outlet_time_zone") })

    navigate(`/mealMenu/${outlet[0].brand_uuid[0]}/${id}`)
  }
  console.log(mealsStatusData)
  const changeSchedule = async (meal_uuid, date, schedule_status) => {
    console.log(meal_uuid, date, schedule_status)

    const response = await axios({
      method: "post",
      url: "https://api.myfooddo.com/meal/ChangeScheduleStatus",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      data:
      {
        meal_uuid, date: (new Date(date)).getTime().toString(), schedule_status
      },

    })
    if (response.data.success) {
      setMealsStatusData([...mealsStatusData.filter(a => a.meal_uuid !== meal_uuid), { meal_uuid, schedule_status: response?.data?.schedule_status }])
      setLoader(false)
    }
    console.log(response)
    return true
  }
  return <div className="itemavilablelity">

    <div className="itemavilabelitycontainer" style={{ backgroundColor: "#fff" }}>
      <div className="itemavilablelity_header">
        <h2>Select A Meal</h2>
        <XIcon style={{ color: "#fff", width: "25px", cursor: "pointer" }} onClick={() => setNewMenu(false)} />
      </div>

      <div className="availablecontainer">
        {mealsData.map(a => events.filter(b => b.name === a.meal_title).filter(b => {
          let c = new Date(isNewMenu)
          let d = new Date(b.start)
          return (c.getDate() === d.getDate() && c.getMonth() === d.getMonth() && c.getFullYear() === d.getFullYear())
        }).length ?
          <div
            key={Math.random()}
            className="input-div"
            style={{ margin: "5px 0", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", position: "relative" }}

          >
            <button style={{ padding: "10px", margin: "10px", border: "none", color: "#fff", backgroundColor: "#4ac959", cursor: "not-allowed", borderRadius: "10px" }}>
              <del> {a.meal_title}</del>

            </button>
            <GreenSwitch
              onClick={(e) => {
                console.log(+mealsStatusData.find(c => c.meal_uuid === a.meal_uuid)?.schedule_status)
                changeSchedule(a.meal_uuid, events.filter(b => b.name === a.meal_title).find(b => {
                  let c = new Date(isNewMenu)
                  let d = new Date(b.start)
                  return (c.getDate() === d.getDate() && c.getMonth() === d.getMonth() && c.getFullYear() === d.getFullYear())
                }).start, +mealsStatusData.find(c => c.meal_uuid === a.meal_uuid)?.schedule_status === 1 ? "0" : "1");
                setLoader(a.meal_uuid)
              }}
              checked={+mealsStatusData.find(c => c.meal_uuid === a.meal_uuid)?.schedule_status}
            />
            <div style={{ position: "absolute", width: "20px", left: "0px", bottom: "2px", display: loader === a.meal_uuid ? "block" : "none" }} >
              <svg viewBox="0 0 100 100">
                <path
                  d="M10 50A40 40 0 0 0 90 50A40 44.8 0 0 1 10 50"
                  fill="black"
                  stroke="none"
                >
                  <animateTransform
                    attributeName="transform"
                    type="rotate"
                    dur="1s"
                    repeatCount="indefinite"
                    keyTimes="0;1"
                    values="0 50 51;360 50 51"
                  ></animateTransform>
                </path>
              </svg>
            </div>
          </div>
          :
          <div
            key={Math.random()}
            className="input-div"
            style={{ margin: "5px 0" }}

          >
            <button type="button" style={{ padding: "10px", margin: "10px", border: "none", color: "#fff", backgroundColor: "#4ac959", cursor: "pointer", borderRadius: "10px" }} onClick={(e) => {
              e.stopPropagation()
              handelSubmit(isNewMenu, a.meal_uuid)
            }}>

              {a.meal_title}
            </button>
          </div>
        )}



      </div>
    </div>
  </div>
}